<template>
  <div>
    <b-modal
      ref="modal-document-orders"
      :title="$t(titleModal)"
      title-tag="h4"
      modal-class="modal-primary"
      size="xl"
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      @hidden="$emit('hideModal')"
    >
      <ValidationObserver ref="ref-validation-document-order">
        <b-card :bg-variant="isDarkSkin ? 'black' : 'white'" class="mb-1">
          <b-row>
            <!-- SERIE -->
            <b-col md="6" lg="4" xl="3">
              <b-form-group label="Serie" label-for="serie">
                <b-skeleton v-if="!finishedLoading" type="input" />
                <b-form-input
                  v-if="finishedLoading"
                  id="serie"
                  v-model="form.serie"
                  v-mask="'####'"
                  trim
                  :disabled="true"
                />
              </b-form-group>
            </b-col>

            <!-- SERIE -->
            <b-col md="6" lg="4" xl="3">
              <b-form-group :label="$t('Number')" label-for="number">
                <b-skeleton v-if="!finishedLoading" type="input" />
                <b-form-input
                  v-if="finishedLoading"
                  id="number"
                  v-model="form.number"
                  v-mask="'########'"
                  trim
                  :disabled="true"
                />
              </b-form-group>
            </b-col>

            <!-- LOAD DATE -->
            <b-col md="6" lg="4" xl="3">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="load_date"
              >
                <b-form-group
                  :label="$t('Load date')"
                  label-for="load_date"
                  :state="errors[0] ? false : null"
                >
                  <b-skeleton v-if="!finishedLoading" type="input" />
                  <b-form-datepicker
                    v-if="finishedLoading"
                    id="load_date"
                    v-model="form.load_date"
                    :class="{ 'border-danger': errors[0] }"
                    :disabled="form.is_travel_finished == 1"
                  ></b-form-datepicker>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <!-- DELIVERY DATE -->
            <b-col md="6" lg="4" xl="3">
              <b-form-group
                :label="$t('Delivery date')"
                label-for="delivery_date"
              >
                <b-skeleton v-if="!finishedLoading" type="input" />
                <b-form-datepicker
                  v-if="finishedLoading"
                  id="delivery_date"
                  v-model="form.delivery_date"
                  :disabled="form.is_travel_finished == 1"
                ></b-form-datepicker>
              </b-form-group>
            </b-col>

            <!-- SERVICE ORDER CODE -->
            <b-col md="6" lg="4" xl="4">
              <b-form-group
                :label="$t('Service order code')"
                label-for="service_order_code"
              >
                <b-skeleton v-if="!finishedLoading" type="input" />
                <b-form-input
                  v-if="finishedLoading"
                  id="service_order_code"
                  type="text"
                  v-model="form.service_order_code"
                  :disabled="documentOrderId != null"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <!-- TRANSPORT NUMBER -->
            <b-col md="6" lg="4" xl="4">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="transport_number"
              >
                <b-form-group
                  :label="$t('Transport number')"
                  :state="errors[0] ? false : null"
                  label-for="transport_number"
                >
                  <b-skeleton v-if="!finishedLoading" type="input" />
                  <b-form-input
                    v-if="finishedLoading"
                    id="transport_number"
                    type="text"
                    v-model="form.transport_number"
                    :class="{ 'border-danger': errors[0] }"
                    :disabled="form.is_travel_finished == 1"
                  ></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <!-- VEHICLE PLATE -->
            <b-col md="6" lg="4" xl="4">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="vehicle_plate"
              >
                <b-form-group
                  :label="$t('Vehicle plate')"
                  :state="errors[0] ? false : null"
                  label-for="vehicle_plate"
                >
                  <b-skeleton v-if="!finishedLoading" type="input" />
                  <b-form-input
                    v-if="finishedLoading"
                    id="vehicle_plate"
                    type="text"
                    v-model="form.vehicle_plate"
                    :class="{ 'border-danger': errors[0] }"
                    :disabled="form.is_travel_finished == 1"
                  ></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <!-- CUSTOMER LOAD REFERENCE -->
            <b-col md="6" lg="8" xl="6">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="customer_load_reference"
              >
                <b-form-group
                  :label="$t('Customer load reference')"
                  :state="errors[0] ? false : null"
                  label-for="customer_load_reference"
                >
                  <b-skeleton v-if="!finishedLoading" type="input" />
                  <b-form-input
                    v-if="finishedLoading"
                    id="customer_load_reference"
                    type="text"
                    v-model="form.customer_load_reference"
                    :class="{ 'border-danger': errors[0] }"
                    :disabled="form.is_travel_finished == 1"
                  ></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <!-- ROUTE -->
            <b-col md="12" lg="4" xl="6">
              <b-form-group :label="$t('Route')" label-for="route">
                <b-skeleton v-if="!finishedLoading" type="input" />
                <b-form-input
                  v-if="finishedLoading"
                  id="route"
                  type="text"
                  v-model="form.route"
                  :disabled="form.is_travel_finished == 1"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <!-- CUSTOMER DESTINATION NAME -->
            <b-col md="12" lg="8" xl="6">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="customer_destination_name"
              >
                <b-form-group
                  :label="$t('Customer destination name')"
                  :state="errors[0] ? false : null"
                  label-for="customer_destination_name"
                >
                  <b-skeleton v-if="!finishedLoading" type="input" />
                  <b-form-input
                    v-if="finishedLoading"
                    id="customer_destination_name"
                    type="text"
                    v-model="form.customer_destination_name"
                    :class="{ 'border-danger': errors[0] }"
                    :disabled="form.is_travel_finished == 1"
                  ></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <!-- DESTINATION ADDRESS -->
            <b-col md="12" lg="8" xl="6">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="destination_address"
              >
                <b-form-group
                  :label="$t('Destination address')"
                  :state="errors[0] ? false : null"
                  label-for="destination_address"
                >
                  <b-skeleton v-if="!finishedLoading" type="input" />
                  <b-form-input
                    v-if="finishedLoading"
                    id="destination_address"
                    type="text"
                    v-model="form.destination_address"
                    :class="{ 'border-danger': errors[0] }"
                    :disabled="form.is_travel_finished == 1"
                  ></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <!-- DESTINATION CODE -->
            <b-col md="6" lg="4" xl="3">
              <b-form-group
                :label="$t('Destination code')"
                label-for="destination_code"
              >
                <b-skeleton v-if="!finishedLoading" type="input" />
                <b-form-input
                  v-if="finishedLoading"
                  id="destination_code"
                  type="text"
                  v-model="form.destination_code"
                  :disabled="form.is_travel_finished == 1"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <!-- DELIVERY POINT CODE -->
            <b-col md="6" lg="4" xl="3">
              <b-form-group
                :label="$t('Delivery point code')"
                label-for="delivery_point_code"
              >
                <b-skeleton v-if="!finishedLoading" type="input" />
                <b-form-input
                  v-if="finishedLoading"
                  id="delivery_point_code"
                  type="text"
                  v-model="form.delivery_point_code"
                  :disabled="form.is_travel_finished == 1"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <!-- LOCALITY -->
            <b-col md="12" lg="4" xl="6">
              <b-form-group :label="$t('Locality')" label-for="locality">
                <b-skeleton v-if="!finishedLoading" type="input" />
                <b-form-input
                  v-if="finishedLoading"
                  id="locality"
                  type="text"
                  v-model="form.locality"
                  :disabled="form.is_travel_finished == 1"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <!-- DELIVERY NUMBER -->
            <b-col md="6" lg="4" xl="3">
              <b-form-group
                :label="$t('Delivery number')"
                label-for="delivery_number"
              >
                <b-skeleton v-if="!finishedLoading" type="input" />
                <b-form-input
                  v-if="finishedLoading"
                  id="delivery_number"
                  type="text"
                  v-model="form.delivery_number"
                  :disabled="form.is_travel_finished == 1"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <!-- REMITTANCE NUMBER -->
            <b-col md="6" lg="4" xl="3">
              <b-form-group
                :label="$t('Remittance number')"
                label-for="remittance_number"
              >
                <b-skeleton v-if="!finishedLoading" type="input" />
                <b-form-input
                  v-if="finishedLoading"
                  id="remittance_number"
                  type="text"
                  v-model="form.remittance_number"
                  :disabled="form.is_travel_finished == 1"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <!-- OBSERVETIONS -->
            <b-col md="12" lg="8" xl="6">
              <b-form-group :label="$t('Observation')" label-for="observation">
                <b-skeleton v-if="!finishedLoading" type="input" />
                <b-form-input
                  v-if="finishedLoading"
                  id="observation"
                  type="text"
                  v-model="form.observations"
                  :disabled="form.is_travel_finished == 1"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </ValidationObserver>

      <b-card
        :bg-variant="isDarkSkin ? 'black' : 'white'"
        title-tag="h5"
        class="mb-1"
      >
        <b-card-title>
          <div class="d-flex justify-content-between">
            <h4>{{ $t("Products") }}</h4>
          </div>
        </b-card-title>

        <ValidationObserver ref="ref-validation-proudcts">
          <div class="d-flex border align-items-center justify-content-between">
            <b-row>
              <!-- PRODUCT CODE -->
              <b-col md="12" lg="3" xl="3" v-if="form.is_travel_finished == 0">
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required"
                  name="product_code"
                >
                  <b-form-group
                    :label="$t('Product code')"
                    :state="errors[0] ? false : null"
                    label-for="product_code"
                  >
                    <b-form-input
                      id="product_code"
                      type="text"
                      v-model="product.product_code"
                      :class="{ 'border-danger': errors[0] }"
                    ></b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <!-- PRODUCT DESCRIPTION -->
              <b-col md="12" lg="5" xl="4" v-if="form.is_travel_finished == 0">
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required"
                  name="product_description"
                >
                  <b-form-group
                    :label="$t('Product description')"
                    :state="errors[0] ? false : null"
                    label-for="product_description"
                  >
                    <b-form-input
                      id="product_description"
                      type="text"
                      v-model="product.product_description"
                      :class="{ 'border-danger': errors[0] }"
                    ></b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <!-- UNIT CODE -->
              <b-col md="12" lg="3" xl="2" v-if="form.is_travel_finished == 0">
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required"
                  name="unit_code"
                >
                  <b-form-group
                    :label="$t('Unit code')"
                    :state="errors[0] ? false : null"
                    label-for="unit_code"
                  >
                    <b-form-input
                      id="unit_code"
                      type="text"
                      v-model="product.unit_code"
                      :class="{ 'border-danger': errors[0] }"
                    ></b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <!-- QUANTITY -->
              <b-col md="3" lg="2" xl="1" v-if="form.is_travel_finished == 0">
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required|min_value:1"
                  name="quantity"
                >
                  <b-form-group
                    :label="$t('Quantity')"
                    :state="errors[0] ? false : null"
                    label-for="quantity"
                  >
                    <b-form-input
                      id="quantity"
                      type="number"
                      v-model="product.quantity"
                      min="0"
                      :class="{ 'border-danger': errors[0] }"
                    ></b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <!-- VOLUME -->
              <b-col md="3" lg="2" xl="1" v-if="form.is_travel_finished == 0">
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required|min_value:1"
                  name="volume"
                >
                  <b-form-group
                    :label="$t('Volume')"
                    :state="errors[0] ? false : null"
                    label-for="volume"
                  >
                    <b-form-input
                      id="volume"
                      type="number"
                      v-model="product.volume"
                      min="0"
                      :class="{ 'border-danger': errors[0] }"
                    ></b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <!-- WEIGHT -->
              <b-col md="3" lg="2" xl="1" v-if="form.is_travel_finished == 0">
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required|min_value:1"
                  name="weight"
                >
                  <b-form-group
                    :label="$t('Weight')"
                    :state="errors[0] ? false : null"
                    label-for="weight"
                  >
                    <b-form-input
                      id="weight"
                      type="number"
                      v-model="product.weight"
                      min="0"
                      :class="{ 'border-danger': errors[0] }"
                    ></b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
            </b-row>
            <b-button
              v-if="form.is_travel_finished == 0"
              variant="outline-primary"
              class="btn-icon ml-1"
              @click="addData()"
            >
              <tabler-icon icon="ChevronsDownIcon" size="18" />
            </b-button>
          </div>

          <b-table
            ref="ref-table-zones"
            hover
            small
            responsive
            class="font-small-3"
            sticky-header="30vh"
            show-empty
            :items="productList"
            :fields="fields"
            :empty-text="$t('No matching records found')"
          >
            <template #cell(product_code)="data">
              <div :class="data.item.deleted ? 'text-danger' : ''">
                {{ data.item.product_code }}
              </div>
            </template>
            <template #cell(product_description)="data">
              <div :class="data.item.deleted ? 'text-danger' : ''">
                {{ data.item.product_description }}
              </div>
            </template>
            <template #cell(unit_code)="data">
              <div :class="data.item.deleted ? 'text-danger' : ''">
                {{ data.item.unit_code }}
              </div>
            </template>
            <template #cell(quantity)="data">
              <div :class="data.item.deleted ? 'text-danger' : ''">
                {{ data.item.quantity }}
              </div>
            </template>
            <template #cell(weight)="data">
              <div :class="data.item.deleted ? 'text-danger' : ''">
                {{ data.item.weight }}
              </div>
            </template>
            <template #cell(volume)="data">
              <div :class="data.item.deleted ? 'text-danger' : ''">
                {{ data.item.volume }}
              </div>
            </template>
            <template #cell(actions)="data">
              <div v-if="form.is_travel_finished == 0">
                <feather-icon
                  v-if="data.item.deleted"
                  icon="RotateCcwIcon"
                  class="text-success cursor-pointer"
                  @click="data.item.deleted = false"
                />
                <feather-icon
                  v-else
                  icon="TrashIcon"
                  class="text-danger cursor-pointer"
                  @click="deleteProduct(data)"
                />
              </div>
            </template>
          </b-table>
        </ValidationObserver>
      </b-card>
      <b-card :bg-variant="isDarkSkin ? 'black' : 'white'" class="mb-1">
        <b-row>
          <b-col cols="12">
            <b-card class="mb-0">
              <div class="d-flex justify-content-between">
                <div>
                  {{ $t("Products selected") }} :
                  <span class="text-primary">
                    {{ getTotalSelected }} Items
                  </span>
                </div>
                <div>
                  {{ $t("Quantity") }} :
                  <span class="text-info">
                    {{ getTotalQuantitySelected }}
                  </span>
                </div>
                <div>
                  {{ $t("Volume") }} :
                  <span class="text-primary">
                    {{ getTotalVolumeSelected }} M3
                  </span>
                </div>
                <div>
                  {{ $t("Weight") }} :
                  <span class="text-warning">
                    {{ getTotalWeightSelected }}
                  </span>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
      <template #modal-footer>
        <b-container fluid>
          <b-row>
            <b-col class="d-flex align-items-center justify-content-end p-0">
              <b-button
                class="mr-1"
                @click="$emit('hideModal', false)"
                v-t="'CANCEL'"
              >
              </b-button>
              <b-button variant="primary" @click="saveDocumentOrder()">
                {{ $t(titleButton) }}
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>
  </div>
</template>

<script>
/* Service */
import DocumentOrderService from "@/views/operations/views/document-orders/services/document-orders.service.js";
import Fields from "@/views/operations/views/document-orders/data/document-orders.fields.js";
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      form: {
        is_travel_finished: 0,
      },
      fields: Fields,
      productList: [],
      product: {
        id: null,
        delivery_date: null,
        load_date: null,
      },
      finishedLoading: false,
    };
  },
  props: {
    documentOrderId: {
      type: Number,
      default: null,
    },
  },
  mounted() {
    this.toggleModal("modal-document-orders");
  },
  async created() {
    this.addPreloader();
    this.finishedLoading = false;
    try {
      await Promise.all([this.getDocumentOrder()]);
    } catch (error) {
      console.log(error);
      this.showToastError("Proceso fallido", "Error");
    } finally {
      this.finishedLoading = true;
      this.removePreloader();
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    titleModal() {
      return this.documentOrderId == null
        ? "NEW DOCUMENT ORDER"
        : "EDIT DOCUMENT ORDER";
    },
    titleButton() {
      return this.documentOrderId == null ? "SAVE" : "UPDATE";
    },
    getTotalSelected() {
      return this.productList.length;
    },
    getTotalQuantitySelected() {
      let quantity = 0;
      this.productList.map((product) => {
        quantity += parseInt(product.quantity);
      });

      return quantity;
    },
    getTotalVolumeSelected() {
      let volume = 0;
      this.productList.map((product) => {
        volume += parseFloat(product.volume);
      });
      return volume.toFixed(3);
    },
    getTotalWeightSelected() {
      let weight = 0;
      this.productList.map((product) => {
        weight += parseFloat(product.weight);
      });
      return weight.toFixed(3);
    },
  },
  methods: {
    async saveDocumentOrder() {
      const result = await this.$refs[
        "ref-validation-document-order"
      ].validate();
      if (!result) return;

      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;

      const params = {
        document_order_id: this.documentOrderId,
        service_order_id: this.form.service_order_id,
        imported_file_id: this.form.imported_file_id,
        created_by: this.currentUser.employee_id,
        // serie: this.form.serie,
        service_order_code: this.form.service_order_code,
        destination_address: this.form.destination_address,
        customer_load_reference: this.form.customer_load_reference,
        customer_destination_name: this.form.customer_destination_name,
        vehicle_plate: this.form.vehicle_plate,
        destination_code: this.form.destination_code,
        delivery_point_code: this.form.delivery_point_code,
        transport_number: this.form.transport_number,
        locality: this.form.locality,
        delivery_number: this.form.delivery_number,
        remittance_number: this.form.remittance_number,
        route: this.form.route,
        load_date: this.form.load_date,
        required_delivery_date: this.form.delivery_date,
        observations: this.form.observations,
        product_list: this.productList,
      };
      try {
        const { data } = await DocumentOrderService.saveDocumentOrder(params);
        if (data.success) {
          this.showToastSuccess("Successfull process");
          this.$emit("refreshTable");
          this.hideModal();
        } else {
          this.showToastWarning("Error process");
        }
      } catch (error) {
        this.showToastError(error);
      }
    },
    deleteProduct(data) {
      if (data.item.id == null) {
        this.productList.splice(data.index, 1);
      } else {
        this.productList[data.index].deleted = true;
      }
    },
    async addData() {
      const result = await this.$refs["ref-validation-proudcts"].validate();
      if (!result) return;

      this.productList.push(this.product);
      this.product = {};
    },
    async getDocumentOrder() {
      try {
        if (this.documentOrderId == null) return;
        const params = {
          documentOrderId: this.documentOrderId,
        };
        const { data } = await DocumentOrderService.getDocumentOrderById(
          params
        );
        this.form = { ...data[0] };
        let products = JSON.parse(data[0].details);
        this.productList = products == null ? [] : products;
      } catch (error) {
        throw error;
      }
    },
    hideModal() {
      this.$emit("hideModal");
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
</style>